import React, { FC } from 'react';
import { Grid, Input, MenuItem, Select, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';

import { LeaderboardConfig } from 'api';

interface IProps extends WithStyles<typeof styles> {
  configs: LeaderboardConfig[];
  selectedConfig: LeaderboardConfig;
  onChange: (id: unknown) => void;
}

const styles = (theme: Theme) =>
  createStyles({
    textOnly: {
      padding: theme.spacing(2),
      fontSize: theme.typography.pxToRem(16),
      ...theme.mixins.overflowText(180),
    },
    input: {
      backgroundColor: 'transparent',
    },
    selectRoot: theme.mixins.overflowText(180),
    select: {
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
  });

const Header: FC<IProps> = ({ classes, configs, selectedConfig, onChange }) => {
  function renderSingleConfig() {
    return <Typography className={classes.textOnly}>{selectedConfig.title}</Typography>;
  }

  function renderConfigs() {
    return (
      <Select
        fullWidth
        classes={{ root: classes.selectRoot, select: classes.select }}
        input={<Input className={classes.input} />}
        value={selectedConfig.id}
        onChange={event => onChange(event.target.value)}>
        {configs.map(config => (
          <MenuItem key={config.id} value={config.id}>
            {config.title}
          </MenuItem>
        ))}
      </Select>
    );
  }

  return (
    <Grid container alignItems="center">
      <Grid item>
        <StarIcon color="secondary" />
      </Grid>
      <Grid item xs>
        {configs.length === 1 ? renderSingleConfig() : renderConfigs()}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(Header);
